module.exports = __webpack_public_path__ + "static/media/industrial.df1e5583.svg";